"use client"

import { useDialogModal } from "@/hook/handle-modal/hooks/actions"
import { useUpdateTermStatusMutation } from "@/services/generate-term/generate-term"
import { Button } from "@/components/ui/button"
import { useToast } from "components/ui/use-toast"

interface CancelTermModalProps {
    id: string
}

const CancelTermModal = ({ id }: CancelTermModalProps) => {
    const [updateTermStatus] = useUpdateTermStatusMutation()
    const { toast } = useToast()
    const { handleModal } = useDialogModal()

    const handleCancelTerm = async () => {
        try {
            await updateTermStatus({
                termId: id,
                status: "CANCELED",
                comment: "TERMO CANCELADO",
            }).unwrap()
            toast({
                description: "Termo Cancelado com sucesso",
                variant: "default",
            })
            handleModal({
                isOpen: false,
            })
        } catch (error) {
            console.error("Erro ao Cancelar termo", error)
            toast({
                description: "Erro ao Cancelar termo",
                variant: "destructive",
            })
            handleModal({
                isOpen: false,
            })
        }
    }

    const handleGoBack = () => {
        handleModal({
            isOpen: false,
        })
    }

    return (
        <div className="flex flex-col items-center gap-6 text-center">
            <p className="text-muted-foreground">
             Tem certeza que deseja cancelar esta solicitação? Esta ação não poderá ser desfeita
            </p>

            <div className="flex w-full gap-3 mt-2">
                <Button variant="outline" className="flex-1" onClick={handleGoBack}>
                    Voltar
                </Button>
                <Button className="flex-1" onClick={handleCancelTerm}>
                    Confirmar
                </Button>
            </div>
        </div>
    )
}

export default CancelTermModal
